import { AxiosError, AxiosResponse } from 'axios';
import { isServerError } from 'src/hooks/use-axios';

const type =
  'https://problem.prisma-capacity.eu/token-authenication-missing-claims';

export type TokenAuthenticationMissingClaimsResponse = {
  type: typeof type;
  title: 'Required claims are missing.';
  status: 401;
};

export type TokenAuthenticationMissingClaims = Omit<AxiosError, 'response'> & {
  response: AxiosResponse<TokenAuthenticationMissingClaimsResponse>;
};

export function isTokenAuthenticationMissingClaims(
  err: unknown
): err is TokenAuthenticationMissingClaims {
  return (
    isServerError(err) &&
    !!err.response.data &&
    (err.response.data as any).type === type
  );
}
